import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'ngx-link-to',
  templateUrl: './link-to.component.html',
  styleUrls: ['./link-to.component.scss']
})
export class LinkToComponent implements OnInit {

  @Input() text: any;
  @Input() link: any;
  @Input() title: any;
  @Input() iconClass: any;
  @Input() classList: any;

  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  routeTo() {
    this.router.navigate([this.link]);
  }

}
